var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04175 5.54183C2.04175 2.80341 4.26166 0.583496 7.00008 0.583496C9.7385 0.583496 11.9584 2.80341 11.9584 5.54183C11.9584 7.64439 10.757 9.60018 9.64069 10.9769C9.07359 11.6763 8.5079 12.2513 8.08421 12.6515C7.87199 12.8519 7.69446 13.0093 7.56891 13.1176C7.50611 13.1717 7.45625 13.2136 7.42148 13.2424L7.38088 13.2757L7.36956 13.2849L7.36623 13.2876L7.36516 13.2885C7.36501 13.2886 7.36449 13.289 7.00008 12.8335L6.63539 13.2888L6.63393 13.2876L6.6306 13.2849L6.61928 13.2757L6.57869 13.2424C6.54391 13.2136 6.49405 13.1717 6.43125 13.1176C6.30571 13.0093 6.12817 12.8519 5.91596 12.6515C5.49226 12.2513 4.92657 11.6763 4.35947 10.9769C3.2432 9.60018 2.04175 7.64439 2.04175 5.54183ZM6.63539 13.2888C6.84843 13.4592 7.15144 13.4594 7.36449 13.289L7.00008 12.8335C6.63568 13.289 6.63554 13.2889 6.63539 13.2888ZM4.66675 5.54183C4.66675 4.25317 5.71142 3.2085 7.00008 3.2085C8.28874 3.2085 9.33341 4.25317 9.33341 5.54183C9.33341 6.83049 8.28874 7.87516 7.00008 7.87516C5.71142 7.87516 4.66675 6.83049 4.66675 5.54183Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b3bea582271f1d72917ed71fcdcfc151.svg";
export { ForwardRef as ReactComponent };